export const AppConstants = {
    paths: {
        data_base: 'assets/data/',
        images:  'assets/data/images/'
    },
};

